import React from 'react';
import './CarouselItem.css';

const CarouselItem: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="carouselItem">{children}</div>;
};

export default CarouselItem;
